"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    /**
     * env for development use ONLY!!
     * DON'T USE IT IN PRODUCTION
     */
    Environment["development"] = "development";
    /**
     * env for production use.
     */
    Environment["production"] = "production";
    /**
     * env for test use.
     */
    Environment["test"] = "test";
})(Environment || (exports.Environment = Environment = {}));
